import {Injectable, Pipe, PipeTransform} from '@angular/core';
import {MasterOperationModel} from "web-shared";
import {ProcessSelectorModel} from "web-shared";

@Pipe({
  name: 'showByValidCondition'
})
@Injectable({
  providedIn: 'root'
})
export class ShowByValidConditionPipe implements PipeTransform {
  transform(entitiesWithValidCondition: any, validConditionFilter: string, showPhantoms: boolean, operation: MasterOperationModel = null, processSelectors: ProcessSelectorModel[] = null) {
    if (!showPhantoms) {
      entitiesWithValidCondition = entitiesWithValidCondition.filter(entity => !entity.IsPhantom);
    }

    if (!validConditionFilter) {
      return entitiesWithValidCondition;
    }
    return entitiesWithValidCondition.filter(entity => {
      const taskSelector = operation?.TaskSelectors?.find(ts => entity.TaskSelectorId && ts.Id === entity.TaskSelectorId);
      const processSelector = processSelectors?.find(ps => entity.ProcessSelectorId && ps.Id === entity.ProcessSelectorId);
      return (!entity || (entity.ValidCondition.Formula ?? {Formula: 'True'}) === validConditionFilter)
        && (!operation || (operation.ValidCondition.Formula ?? {Formula: 'True'}) === validConditionFilter)
        && (!taskSelector || (taskSelector.ValidCondition.Formula ?? {Formula: 'True'}) === validConditionFilter)
        && (!processSelector || (processSelector.ValidCondition.Formula ?? {Formula: 'True'}) === validConditionFilter);
    });
  }
}
